import { AnalyticsStore, codeSplit, Controller, FetchOptions, Result } from 'bernie-core';

import { UiStore, IndustryStore } from 'stores';
import { PageData } from 'bernie-http';
import '../client/temp-common-imports';

// util
import { pageNames } from '../data/page-names';
import analyticsUtil from '../util/AnalyticsUtil';

export class SignUpController implements Controller {
  public pageId = pageNames.signUp;
  public path = '/:localeName/signup';
  public routeName = 'signup';
  public bundles = [];

  public component = codeSplit(() => import(/* webpackChunkName: "signup-page" */ '../views/signup-page'));
  public exact = true;

  // tslint:disable-next-line:prefer-function-over-method
  public fetch(options: FetchOptions) {
    const { stores, request } = options;
    const analyticsStore: AnalyticsStore = stores && stores.get<AnalyticsStore>('analytics');

    const uiStore = stores?.get<UiStore>('uiStore');
    uiStore?.setPageName(this.pageId);

    analyticsUtil.runAnalytics(this.pageId, analyticsStore, request.context);

    return Promise.resolve(Result.ok());
  }

  // tslint:disable-next-line:prefer-function-over-method
  public fetchPageData(): Promise<PageData> {
    return Promise.resolve({ title: 'Affiliate Hub Sign-up' }) as Promise<PageData>;
  }
}
